import { Tag } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'translations/hooks';

import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';

export const StatusTag = ({ status }: { status: string }) => {
  const { t } = useTranslation();

  const color = useMemo(() => {
    switch (status) {
      case Quality_SegmentHistoryStatusEnum_Enum.OnHold:
        return {
          text: '#666666',
          background: '#EDEDED',
          border: '#D9D9D9',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.Accepted:
        return {
          text: '#2966FF',
          background: '#D5EAFF',
          border: '#C0DBF6',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.Rejected:
        return {
          text: '#AB2001',
          background: '#FFE6DD',
          border: '#FFE2DD',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.Imported:
        return {
          text: '#666666',
          background: '#EDEDED',
          border: '#D9D9D9',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.Quarantine:
        return {
          text: '#C67402',
          background: '#FFF8DD',
          border: '#F5E9BE',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.Installed:
        return {
          text: '#01AB61',
          background: '#DDFFE4',
          border: '#C9FAD8',
        };
      case Quality_SegmentHistoryStatusEnum_Enum.TunnelRejected:
        return {
          text: '#AB2001',
          background: '#FFE6DD',
          border: '#FFE2DD',
        };
      default:
        return {
          text: '#666666',
          background: '#EDEDED',
          border: '#D9D9D9',
        };
    }
  }, [status]);

  let tableStatus = status;
  if (
    !Object.values(Quality_SegmentHistoryStatusEnum_Enum).includes(
      tableStatus as Quality_SegmentHistoryStatusEnum_Enum,
    )
  ) {
    tableStatus = 'UNKNOWN';
  }

  return (
    <Tag
      style={{
        color: color.text,
        borderColor: color.border,
        backgroundColor: color.background,
        borderRadius: 10,
      }}
    >
      <span>&#x25CF; </span>
      {t(`qualityControl.segmentHistory.status.state`, {
        context: tableStatus,
      })}
    </Tag>
  );
};
